export class StartWorkflow {
    Id: number;
    BusinessKey: string;
    Variables: { [key: string]: string };
  }